import React from "react";
import "./index.scss";

export default function Title({ text }) {
  return <h2 className="intro-title">{text}</h2>;
}
